export default () => {
	const sections = document.querySelectorAll('.category-list');

	sections.forEach(function(section) {
		const links = section.querySelectorAll('.category-list__link');
		const images = section.querySelectorAll('.category-list__box');

		if (links.length && images.length) {
			links.forEach(function(link, i) {
				link.addEventListener('mouseenter', (e) => {
					images[i].style.opacity = 1;
				});
				link.addEventListener('mouseleave', (e) => {
					images[i].style.opacity = 0;
				});
			});
		}
	});
}